import React, { useEffect } from "react";
import { Route, Switch } from "react-router";
import { useHistory } from "react-router-dom";
import ProductManager from "@iso/pages/ProductManager/index";
import ProfileSetting from "@iso/pages/ProfileSetting/index";
import PrivateRoute from "./PrivateRoute/index";
import Login from "@iso/pages/Login/index";
import StaffSetting from "@iso/pages/StaffSetting/index";
import GroupRole from "@iso/pages/GroupRole/index";
import GroupRoleDetail from "@iso/pages/GroupRole/GroupRoleDetail";
import AssignStore from "@iso/pages/StaffSetting/AssignStore";
import GroupRoleStaff from "@iso/pages/StaffSetting/GroupRoleStaff";
import Auth from "@iso/pages/Auth/index";
import Register from "@iso/pages/Register/index";
import ChooseSystem from "@iso/pages/ChooseSystem/index";
import StoreManager from "@iso/pages/StoreManager/index";
import LangManager from "@iso/pages/LangManager/index";
import MenuItemManager from "@iso/pages/MenuItemManager/index";
import ClearCache from "@iso/pages/ClearCache/index";
import AddEditProduct from "@iso/pages/ProductManager/AddEditProduct";
import ProductDetail from "@iso/pages/ProductManager/ProductDetail/index";
import StoreDetail from "@iso/pages/StoreManager/StoreDetail";
import AddOnManager from "@iso/pages/AddOnManager";
import AttributeManagement from "@iso/pages/AttributeManager";
import ScheduleSurchargeManager from "@iso/pages/ScheduleSurchargeManager";
import MenuMaster from "@iso/pages/MenuMaster";
import MenuStoreChannel from "@iso/pages/MenuStoreChannel";
import { API_FEEDBACK, API_AUTH_URL } from "../config";
import BannerManager from "@iso/pages/BannerManager";
import AddEditBanner from "@iso/pages/BannerManager/AddEditBanner";
import MenuDisplayConfig from "@iso/pages/MenuDisplayConfig";
import { OidcProvider } from "@iso/helpers/oidc";
import LazyLoading from "../component/LazyLoading";

const configuration = {
   authority: API_AUTH_URL,
   client_id: "back_office",
   redirect_uri: window.location.origin + "/mms/authentication/callback",
   post_logout_redirect_uri: window.location.origin + "/mms",
   scope: "openid profile email offline_access CMS KMS Messenger Identity Deli Evoucher",
   demonstrating_proof_of_possession: false,
   // service_worker_relative_url: "/OidcServiceWorker.js", // just comment that line to disable service worker mode
   service_worker_only: false,
};

function AppRoutes() {
   useEffect(() => {
      document
         .getElementById("my-manifest-placeholder")
         .setAttribute(
            "href",
            `${API_FEEDBACK}/webstore/manifest?st=4ps&url=${window.location.origin}&startUrl=${window.location.origin}&name=BO Pizza 4P's`
         );
   }, []);

   return (
      <Switch>
         <Route path="/" exact={true} component={Auth} />
         <Route path="/login" exact={true} component={Login} />
         <Route path="/register" exact={true} component={Register} />

         <PrivateRoute
            path="/product"
            exact={true}
            component={<ProductManager />}
         />
         <PrivateRoute
            path="/product/edit-product/:id"
            exact={true}
            component={<AddEditProduct />}
         />
         <PrivateRoute
            path="/product/add-product"
            exact={true}
            component={<AddEditProduct />}
         />
         <PrivateRoute
            path="/product/product-detail"
            exact={true}
            component={<ProductDetail />}
         />

         <PrivateRoute
            path="/product/add-on/:id"
            exact={true}
            component={<AddOnManager />}
         />
         <PrivateRoute
            path="/product/add-on"
            exact={true}
            component={<AddOnManager />}
         />
         <PrivateRoute
            path="/product/attribute"
            exact={true}
            component={<AttributeManagement />}
         />
         <PrivateRoute
            path="/store"
            exact={true}
            component={<StoreManager />}
         />
         <PrivateRoute
            path="/store/detail/:id"
            exact={true}
            component={<StoreDetail />}
         />
         <PrivateRoute path="/lang" exact={true} component={<LangManager />} />
         <PrivateRoute
            path="/menu-item"
            exact={true}
            component={<MenuItemManager />}
         />
         <PrivateRoute
            path="/clear-cache"
            exact={true}
            component={<ClearCache />}
         />
         <PrivateRoute
            path="/choose-system"
            exact={true}
            component={<ChooseSystem />}
         />
         <PrivateRoute
            path="/profile-setting"
            exact={true}
            component={<ProfileSetting />}
         />
         <PrivateRoute
            path="/root/staff-setting"
            exact={true}
            component={<StaffSetting />}
         />
         <PrivateRoute
            path="/root/staff-setting/assign-store/:id"
            exact={true}
            component={<AssignStore />}
         />
         <PrivateRoute
            path="/root/staff-setting/group-role/:id"
            exact={true}
            component={<GroupRoleStaff />}
         />
         <PrivateRoute
            path="/root/group-role"
            exact={true}
            component={<GroupRole />}
         />
         <PrivateRoute
            path="/root/group-role/:id"
            exact={true}
            component={<GroupRoleDetail />}
         />
         <PrivateRoute
            path="/root/group-role/:id"
            exact={true}
            component={<GroupRoleDetail />}
         />
         <PrivateRoute
            path="/schedule-surcharge"
            exact={true}
            component={<ScheduleSurchargeManager />}
         />
         <PrivateRoute
            path="/menu/menu-master"
            exact={true}
            component={<MenuMaster />}
         />
         <PrivateRoute
            path="/menu/menu-store-channel"
            exact={true}
            component={<MenuStoreChannel />}
         />
         <PrivateRoute
            path="/menu/display-menu"
            exact={true}
            component={<MenuDisplayConfig />}
         />
         <PrivateRoute
            path="/banner/edit-banner/:id"
            exact={true}
            component={<AddEditProduct />}
         />
         <PrivateRoute
            path="/banner"
            exact={true}
            component={<BannerManager />}
         />
         <PrivateRoute
            path="/banner/add-banner"
            exact={true}
            component={<AddEditBanner />}
         />
      </Switch>
   );
}

function AppRoutesHOC() {
   const history = useHistory();
   const withCustomHistory = () => {
      return {
         replaceState: (url) => {
            const path = url.replace("/mms", "") || "/";
            history.replace(path);
            window.dispatchEvent(new Event("popstate"));
         },
      };
   };

   return (
      <OidcProvider
         configuration={configuration}
         withCustomHistory={withCustomHistory}
         loadingComponent={LazyLoading}
         authenticatingComponent={LazyLoading}
         callbackSuccessComponent={LazyLoading}
      >
         <AppRoutes />
      </OidcProvider>
   );
}

export default AppRoutesHOC;
